import React from 'react'
import PropTypes from 'prop-types'

const StartDateIcon = ({ className, id }) => (
  <svg
    className={className}
    fill="none"
    height="75"
    id={id}
    viewBox="0 0 75 75"
    width="75"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_621_462)">
      <circle cx="37.5" cy="37.5" fill="url(#paint0_linear_621_462)" r="37.5" />
      <rect
        height="32.7"
        rx="4.35"
        stroke="white"
        strokeWidth="1.3"
        width="43.7"
        x="15.65"
        y="21.65"
      />
      <rect fill="white" height="5" rx="1.5" width="3" x="25" y="19" />
      <rect fill="white" height="5" rx="1.5" width="3" x="47" y="19" />
      <line
        stroke="white"
        strokeWidth="1.3"
        x1="16"
        x2="59"
        y1="28.35"
        y2="28.35"
      />
      <circle cx="23.5" cy="41.5" fill="white" fillOpacity="0.5" r="1.5" />
      <circle cx="23.5" cy="47.5" fill="white" fillOpacity="0.5" r="1.5" />
      <circle cx="30.5" cy="35.5" fill="white" fillOpacity="0.5" r="1.5" />
      <circle cx="30.5" cy="41.5" fill="white" fillOpacity="0.5" r="1.5" />
      <circle cx="30.5" cy="47.5" fill="white" fillOpacity="0.5" r="1.5" />
      <circle cx="37.5" cy="35.5" fill="white" fillOpacity="0.5" r="1.5" />
      <circle cx="37.5" cy="41.5" fill="white" fillOpacity="0.5" r="1.5" />
      <circle cx="37.5" cy="47.5" fill="white" fillOpacity="0.5" r="1.5" />
      <circle cx="44.5" cy="35.5" fill="white" fillOpacity="0.5" r="1.5" />
      <circle cx="44.5" cy="41.5" fill="white" fillOpacity="0.5" r="1.5" />
      <circle cx="44.5" cy="47.5" fill="white" fillOpacity="0.5" r="1.5" />
      <circle cx="51.5" cy="35.5" fill="white" fillOpacity="0.5" r="1.5" />
      <circle cx="51.5" cy="41.5" fill="white" fillOpacity="0.5" r="1.5" />
      <circle cx="51.5" cy="47.5" fill="white" fillOpacity="0.5" r="1.5" />
      <path
        d="M23.2229 32.6687C23.3252 32.4218 23.6748 32.4218 23.7771 32.6687L24.3533 34.0589C24.3965 34.1631 24.4945 34.2342 24.6069 34.2431L26.1071 34.3615C26.3735 34.3825 26.4816 34.7151 26.2784 34.8886L25.1343 35.8663C25.0486 35.9395 25.0111 36.0546 25.0374 36.1643L25.3884 37.6277C25.4508 37.8875 25.1679 38.0931 24.94 37.9535L23.6567 37.1675C23.5605 37.1086 23.4395 37.1086 23.3433 37.1675L22.06 37.9535C21.8321 38.0931 21.5492 37.8875 21.6116 37.6277L21.9626 36.1643C21.9889 36.0546 21.9514 35.9395 21.8657 35.8663L20.7216 34.8886C20.5184 34.7151 20.6265 34.3825 20.8929 34.3615L22.3931 34.2431C22.5055 34.2342 22.6035 34.1631 22.6467 34.0589L23.2229 32.6687Z"
        fill="white"
      />
      <path
        d="M16 26C16 23.7909 17.7909 22 20 22H55C57.2091 22 59 23.7909 59 26V28H16V26Z"
        fill="white"
        fillOpacity="0.35"
      />
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_621_462"
        x1="51"
        x2="-2.42889e-07"
        y1="20"
        y2="107.5"
      >
        <stop stopColor="#04817C" />
        <stop offset="1" stopColor="#002855" />
      </linearGradient>
      <clipPath id="clip0_621_462">
        <rect fill="white" height="75" width="75" />
      </clipPath>
    </defs>
  </svg>
)

StartDateIcon.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
}

export default StartDateIcon
